export default __webpack_public_path__ + "static/B0199-369dbbcebd888b179c8054aa6f6ab17c.png";